module.exports = __webpack_public_path__ + "093ece2fdf3cc96d9a14464ba57de04a.png";